import React, { ReactNode, useContext } from 'react';
import NewCourseDefaultImg from '../../images/newCourseDetail.svg';
import {
  ConfigContext,
  withLocalization,
  withLocalizationProps,
} from '../../context/Config';
import SmallCourseCardSkeleton from './SmallCourseCardSkeleton';
import withSkeleton from '../../hoc/withSkeleton';
import Text from '../Text';
import SmallImageCard from '../SmallImageCard';
import './SmallCourseCard.less';

export type SmallCourseType = {
  id?: string;
  name?: string | ReactNode;
  description?: string;
  groupTitle?: string;
  startDate?: string;
  endDate?: string;
  teachers?: Array<{
    fullName: string;
    image: string;
  }>;
  level?: string;
  studentsCount?: number | ReactNode;
  image?: string;
  trainingLinks?: { [key: string]: string };
  practiceLink?: string;
  isFlexible?: boolean;
  price?: string;
};

export type SmallCourseCardProps = {
  course: SmallCourseType;
  contentHeight?: string;
  image?: string;
  actions?: ReactNode;
  dotMenu?: ReactNode;
  userIconFill?: '';
  sessionDate?: any;
};

const TSmallCourseCard: React.FC<
  SmallCourseCardProps & withLocalizationProps
> = ({
  moment,
  course,
  contentHeight = '110px',
  actions,
  sessionDate,
  dotMenu,
}) => {
  const { translate } = useContext(ConfigContext);
  return (
    <SmallImageCard
      dotMenu={<div className="t-dot-menu">{dotMenu}</div>}
      image={course.image || NewCourseDefaultImg}
    >
      <div
        style={{ height: contentHeight }}
        className="t-smallCourseCardContent"
      >
        <div className="t-smallCardContentRow-1">
          <div className="t-smallCourseCardTitle">
            <Text
              title={String(course.groupTitle || '')}
              textColor="dark-100"
              bold
              level={1}
              rows={1}
            >
              {course.groupTitle || ''}
            </Text>
            <Text textColor="dark-50" semiBold level={2} rows={1}>
              {course.name || ''}
            </Text>
          </div>
          <div className="t-action-row">
            {sessionDate ? (
              <Text level={3} rows={1}>
                {sessionDate}
              </Text>
            ) : (
              <Text level={3} rows={1}>
                {translate('You don’t have any assignment')}
              </Text>
            )}
            {actions && <div className="actions-wrapper">{actions}</div>}
          </div>
        </div>
      </div>
    </SmallImageCard>
  );
};

export default withSkeleton(
  withLocalization(TSmallCourseCard),
  SmallCourseCardSkeleton,
);
